import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Главная страница анонимного чата ${ctx.brand}`,
    languageButtonLabel: `Язык`,
    languageModalTitle: `Выберите язык`,
    languageModalCloseLabel: `Закрыть меню языков`,
  },
  languageOptions: {
    'en-US': {
      label: `Английский (Соединенные Штаты)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Английский (Кения)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Английский (Нигерия)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Английский (Сингапур)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Португальский (Португалия)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Португальский (Бразилия)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Немецкий (Германия)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Немецкий (Австрия)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Немецкий (Швейцария)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Испанский (Испания)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Французский (Франция)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Итальянский (Италия)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Нидерландский (Нидерланды)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Польский (Польша)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Шведский (Швеция)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Датский (Дания)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Финский (Финляндия)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Норвежский (Норвегия)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Исландский (Исландия)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Японский (Япония)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Корейский (Республика Корея)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Китайский (Китай)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Кантонский (Гонконг (САР))`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Вьетнамский (Вьетнам)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Тайский (Таиланд)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Индонезийский (Индонезия)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Суахили (Кения)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Хинди (Индия)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Бенгальский (Бангладеш)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Маратхи (Индия)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Телугу (Индия)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Персидский (Иран)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Урду (Пакистан)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Панджаби (Пакистан)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Нигерийско-креольский (Нигерия)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Русский (Россия)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Арабский (Саудовская Аравия)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Арабский (ОАЭ)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Арабский (Катар)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Марокканский арабский (Марокко)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Турецкий (Турция)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Выберите язык`,
    closeLabel: `Закрыть меню языков`,
  },
  languageHint: (ctx) => `Переключайтесь между ${ctx.localesCount}+ локалями без создания аккаунта.`,
  readPagePrompt: ({languageLabel}) => `Прочитать эту страницу на ${languageLabel}.`,
};
